import { api } from "@/api";

export default class API {
  static putAcceptTerm() {
    return api.put(`/v1/me/aceitar-termos/`);
  }
}
